import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  Grid,
  makeStyles,
  Select,
  Typography,
} from "@material-ui/core";
import { OrderCard } from "../../../../components";
import { MdFilterList } from "react-icons/md";
import { useSelector } from "react-redux";
import { backend } from "../../../../api";
import { toast } from "react-toastify";
import { Skeleton } from "@material-ui/lab";
import { Pagination } from "@mui/material"; // Import Pagination

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "5px",
    marginTop: "30px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  },
  tabHeading: {
    fontSize: "32px",
    fontWeight: 550,
    margin: "0",
  },
  filterSelect: {
    width: 120,
  },
}));

function Orders() {
  const classes = useStyles();
  const state = useSelector((state) => state.auth);
  const [orders, setOrders] = useState([]);
  const [ordersList, setOrdersList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 6; // Number of orders per page

  const handleFilterOrder = (e) => {
    if (e.target.value === "all") {
      setOrdersList(orders);
    } else {
      setOrdersList(orders.filter((order) => order.status === e.target.value));
    }
    setCurrentPage(1); // Reset to the first page when filtering
  };

  const handleFetchOrders = () => {
    backend
      .get(`/bookorder?user=${state.currentUser._id}`)
      .then((res) => {
        setOrders(res.data.data);
        console.log("data", res.data.data);
        setOrdersList(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.response ? err.response.data.message : err.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    handleFetchOrders();
  }, []);

  // Get current orders
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = ordersList.slice(indexOfFirstOrder, indexOfLastOrder);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <h2 className={classes.tabHeading}>My Orders</h2>
        <Box display="flex" alignItems="center">
          <MdFilterList style={{ margin: "0 5px", fontSize: 20 }} />
          <FormControl variant="outlined" className={classes.filterSelect}>
            <Select native onChange={handleFilterOrder}>
              <option value="all">All</option>
              <option value="requested">Requested</option>
              <option value="placed">Placed</option>
              <option value="shipped">Shipped</option>
              <option value="delivered">Delivered</option>
              <option value="cancelled">Cancelled</option>
              <option value="declined">Declined</option>
            </Select>
          </FormControl>
        </Box>
      </Box>
      <Box style={{ width: "95%", margin: "30px auto" }}>
        <Grid container spacing={3}>
          {loading ? (
            Array.from(new Array(6)).map((_, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Skeleton variant="rect" height={250} />
              </Grid>
            ))
          ) : currentOrders.length > 0 ? (
            currentOrders.map((order) => (
              <Grid item xs={12} md={6} key={order.id}>
                <OrderCard order={order} />
              </Grid>
            ))
          ) : (
            <Grid>
              <Typography
                variant="h2"
                color="error"
              >
                No orders exist.
              </Typography>
            </Grid>
          )}
        </Grid>
        {ordersList.length > ordersPerPage && (
          <Box display="flex" justifyContent="center" mt={4}>
            <Pagination
              count={Math.ceil(ordersList.length / ordersPerPage)}
              page={currentPage}
              onChange={handlePageChange}
              sx={{
                "& .MuiPaginationItem-root": {
                  "&:hover": {
                    backgroundColor: "#FECE00",
                  },
                },
                "& .Mui-selected": {
                  backgroundColor: "#FECE00",
                  color: "#000",
                },
                "& .MuiPaginationItem-ellipsis": {
                  color: "#FECE00",
                },
              }}
            />
          </Box>
        )}
      </Box>
    </div>
  );
}

export default Orders;
